/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as DataDeletionRouteImport } from './routes/data-deletion'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAssetsRouteImport } from './routes/_authenticated/assets'
import { Route as AuthenticatedConnectGa4PropertyRouteImport } from './routes/_authenticated/connect-ga4-property'
import { Route as AuthenticatedConnectGoogleAccountRouteImport } from './routes/_authenticated/connect-google-account'
import { Route as AuthenticatedConnectGtmContainerRouteImport } from './routes/_authenticated/connect-gtm-container'
import { Route as AuthenticatedConnectMetaAssetsRouteImport } from './routes/_authenticated/connect-meta-assets'
import { Route as AuthenticatedConnectPlatformsRouteImport } from './routes/_authenticated/connect-platforms'
import { Route as AuthenticatedConnectorsRouteImport } from './routes/_authenticated/connectors'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedExtendTrialRouteImport } from './routes/_authenticated/extend-trial'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedOrganizationSetupRouteImport } from './routes/_authenticated/organization-setup'
import { Route as AuthenticatedPaywallRouteImport } from './routes/_authenticated/paywall'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedSupportRouteImport } from './routes/_authenticated/support'
import { Route as AuthenticatedWizardRouteImport } from './routes/_authenticated/wizard'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicSignupRouteImport } from './routes/_public/signup'
import { Route as PublicVerifyEmailRouteImport } from './routes/_public/verify-email'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedAdminAuditRouteImport } from './routes/_authenticated/admin/audit'
import { Route as AuthenticatedAdminIntegrationsRouteImport } from './routes/_authenticated/admin/integrations'
import { Route as AuthenticatedAdminInvitationsRouteImport } from './routes/_authenticated/admin/invitations'
import { Route as AuthenticatedAdminManagedSpendRouteImport } from './routes/_authenticated/admin/managed-spend'
import { Route as AuthenticatedAdminSystemRouteImport } from './routes/_authenticated/admin/system'
import { Route as AuthenticatedAdminUserAnalyticsRouteImport } from './routes/_authenticated/admin/user-analytics'
import { Route as AuthenticatedAgencyIndexRouteImport } from './routes/_authenticated/agency/index'
import { Route as AuthenticatedAgencyBillingRouteImport } from './routes/_authenticated/agency/billing'
import { Route as AuthenticatedAgencyClientsRouteImport } from './routes/_authenticated/agency/clients'
import { Route as AuthenticatedAgencyConnectionsRouteImport } from './routes/_authenticated/agency/connections'
import { Route as AuthenticatedAgencyOnboardingRouteImport } from './routes/_authenticated/agency/onboarding'
import { Route as AuthenticatedAgencySettingsRouteImport } from './routes/_authenticated/agency/settings'
import { Route as AuthenticatedAgencySetupRouteImport } from './routes/_authenticated/agency/setup'
import { Route as AuthenticatedAgencyTeamRouteImport } from './routes/_authenticated/agency/team'
import { Route as AuthenticatedAiPerformanceIndexRouteImport } from './routes/_authenticated/ai-performance/index'
import { Route as AuthenticatedAssetsIndexRouteImport } from './routes/_authenticated/assets/index'
import { Route as AuthenticatedAssetsAssetIdRouteImport } from './routes/_authenticated/assets/$assetId'
import { Route as AuthenticatedAudiencesIndexRouteImport } from './routes/_authenticated/audiences/index'
import { Route as AuthenticatedAudiencesAudienceIdRouteImport } from './routes/_authenticated/audiences/$audienceId'
import { Route as AuthenticatedBillingReturnRouteImport } from './routes/_authenticated/billing/return'
import { Route as AuthenticatedGoalsIndexRouteImport } from './routes/_authenticated/goals/index'
import { Route as AuthenticatedGoalsGoalIdRouteImport } from './routes/_authenticated/goals/$goalId'
import { Route as AuthenticatedInsightsIndexRouteImport } from './routes/_authenticated/insights/index'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSettingsBillingRouteImport } from './routes/_authenticated/settings/billing'
import { Route as AuthenticatedSettingsConnectionsRouteImport } from './routes/_authenticated/settings/connections'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsSecurityRouteImport } from './routes/_authenticated/settings/security'
import { Route as AuthenticatedSettingsTeamRouteImport } from './routes/_authenticated/settings/team'
import { Route as AuthenticatedStrategiesIndexRouteImport } from './routes/_authenticated/strategies/index'
import { Route as AuthenticatedStrategiesStrategyIdRouteImport } from './routes/_authenticated/strategies/$strategyId'
import { Route as AuthenticatedWizardIndexRouteImport } from './routes/_authenticated/wizard/index'
import { Route as AuthenticatedWizardBriefRouteImport } from './routes/_authenticated/wizard/brief'
import { Route as AuthenticatedWizardLaunchedRouteImport } from './routes/_authenticated/wizard/launched'
import { Route as AuthenticatedAdminAiQualityIndexRouteImport } from './routes/_authenticated/admin/ai-quality/index'
import { Route as AuthenticatedAdminAuditReportsIndexRouteImport } from './routes/_authenticated/admin/audit-reports/index'
import { Route as AuthenticatedAdminAuditReportsIntakeIdRouteImport } from './routes/_authenticated/admin/audit-reports/$intakeId'
import { Route as AuthenticatedAdminJobsIndexRouteImport } from './routes/_authenticated/admin/jobs/index'
import { Route as AuthenticatedAdminJobsJobIdRouteImport } from './routes/_authenticated/admin/jobs/$jobId'
import { Route as AuthenticatedAdminLlmUsageIndexRouteImport } from './routes/_authenticated/admin/llm-usage/index'
import { Route as AuthenticatedAdminLlmUsageOrgIdRouteImport } from './routes/_authenticated/admin/llm-usage/$orgId'
import { Route as AuthenticatedAdminOrganizationsIndexRouteImport } from './routes/_authenticated/admin/organizations/index'
import { Route as AuthenticatedAdminOrganizationsOrgIdRouteImport } from './routes/_authenticated/admin/organizations/$orgId'
import { Route as AuthenticatedAdminUsersIndexRouteImport } from './routes/_authenticated/admin/users/index'
import { Route as AuthenticatedAdminUsersUserIdRouteImport } from './routes/_authenticated/admin/users/$userId'
import { Route as AuthenticatedAgencySettingsIndexRouteImport } from './routes/_authenticated/agency/settings/index'
import { Route as AuthenticatedAgencySettingsNotificationsRouteImport } from './routes/_authenticated/agency/settings/notifications'
import { Route as AuthenticatedAgencySettingsSecurityRouteImport } from './routes/_authenticated/agency/settings/security'
import { Route as AuthenticatedStrategiesStrategyIdIndexRouteImport } from './routes/_authenticated/strategies/$strategyId.index'
import { Route as AuthenticatedWizardCampaignsStrategyIdRouteImport } from './routes/_authenticated/wizard/campaigns.$strategyId'
import { Route as AuthenticatedWizardPlanStrategyIdRouteImport } from './routes/_authenticated/wizard/plan.$strategyId'
import { Route as AuthenticatedStrategiesStrategyIdCampaignsCampaignIdRouteImport } from './routes/_authenticated/strategies/$strategyId.campaigns.$campaignId'
import { Route as AuthenticatedWizardCampaignsStrategyIdIndexRouteImport } from './routes/_authenticated/wizard/campaigns.$strategyId.index'
import { Route as AuthenticatedWizardCampaignsStrategyIdCampaignIndexRouteImport } from './routes/_authenticated/wizard/campaigns.$strategyId.$campaignIndex'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const DataDeletionRoute = DataDeletionRouteImport.update({
  id: '/data-deletion',
  path: '/data-deletion',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAssetsRoute = AuthenticatedAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedConnectGa4PropertyRoute =
  AuthenticatedConnectGa4PropertyRouteImport.update({
    id: '/connect-ga4-property',
    path: '/connect-ga4-property',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConnectGoogleAccountRoute =
  AuthenticatedConnectGoogleAccountRouteImport.update({
    id: '/connect-google-account',
    path: '/connect-google-account',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConnectGtmContainerRoute =
  AuthenticatedConnectGtmContainerRouteImport.update({
    id: '/connect-gtm-container',
    path: '/connect-gtm-container',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConnectMetaAssetsRoute =
  AuthenticatedConnectMetaAssetsRouteImport.update({
    id: '/connect-meta-assets',
    path: '/connect-meta-assets',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConnectPlatformsRoute =
  AuthenticatedConnectPlatformsRouteImport.update({
    id: '/connect-platforms',
    path: '/connect-platforms',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConnectorsRoute = AuthenticatedConnectorsRouteImport.update({
  id: '/connectors',
  path: '/connectors',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedExtendTrialRoute =
  AuthenticatedExtendTrialRouteImport.update({
    id: '/extend-trial',
    path: '/extend-trial',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationSetupRoute =
  AuthenticatedOrganizationSetupRouteImport.update({
    id: '/organization-setup',
    path: '/organization-setup',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPaywallRoute = AuthenticatedPaywallRouteImport.update({
  id: '/paywall',
  path: '/paywall',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSupportRoute = AuthenticatedSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWizardRoute = AuthenticatedWizardRouteImport.update({
  id: '/wizard',
  path: '/wizard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignupRoute = PublicSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => PublicRoute,
} as any)
const PublicVerifyEmailRoute = PublicVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => PublicRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminAuditRoute = AuthenticatedAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminIntegrationsRoute =
  AuthenticatedAdminIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminInvitationsRoute =
  AuthenticatedAdminInvitationsRouteImport.update({
    id: '/invitations',
    path: '/invitations',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminManagedSpendRoute =
  AuthenticatedAdminManagedSpendRouteImport.update({
    id: '/managed-spend',
    path: '/managed-spend',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSystemRoute =
  AuthenticatedAdminSystemRouteImport.update({
    id: '/system',
    path: '/system',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminUserAnalyticsRoute =
  AuthenticatedAdminUserAnalyticsRouteImport.update({
    id: '/user-analytics',
    path: '/user-analytics',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAgencyIndexRoute =
  AuthenticatedAgencyIndexRouteImport.update({
    id: '/agency/',
    path: '/agency/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgencyBillingRoute =
  AuthenticatedAgencyBillingRouteImport.update({
    id: '/agency/billing',
    path: '/agency/billing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgencyClientsRoute =
  AuthenticatedAgencyClientsRouteImport.update({
    id: '/agency/clients',
    path: '/agency/clients',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgencyConnectionsRoute =
  AuthenticatedAgencyConnectionsRouteImport.update({
    id: '/agency/connections',
    path: '/agency/connections',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgencyOnboardingRoute =
  AuthenticatedAgencyOnboardingRouteImport.update({
    id: '/agency/onboarding',
    path: '/agency/onboarding',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgencySettingsRoute =
  AuthenticatedAgencySettingsRouteImport.update({
    id: '/agency/settings',
    path: '/agency/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgencySetupRoute =
  AuthenticatedAgencySetupRouteImport.update({
    id: '/agency/setup',
    path: '/agency/setup',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgencyTeamRoute = AuthenticatedAgencyTeamRouteImport.update({
  id: '/agency/team',
  path: '/agency/team',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAiPerformanceIndexRoute =
  AuthenticatedAiPerformanceIndexRouteImport.update({
    id: '/ai-performance/',
    path: '/ai-performance/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssetsIndexRoute =
  AuthenticatedAssetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAssetsRoute,
  } as any)
const AuthenticatedAssetsAssetIdRoute =
  AuthenticatedAssetsAssetIdRouteImport.update({
    id: '/$assetId',
    path: '/$assetId',
    getParentRoute: () => AuthenticatedAssetsRoute,
  } as any)
const AuthenticatedAudiencesIndexRoute =
  AuthenticatedAudiencesIndexRouteImport.update({
    id: '/audiences/',
    path: '/audiences/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAudiencesAudienceIdRoute =
  AuthenticatedAudiencesAudienceIdRouteImport.update({
    id: '/audiences/$audienceId',
    path: '/audiences/$audienceId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBillingReturnRoute =
  AuthenticatedBillingReturnRouteImport.update({
    id: '/billing/return',
    path: '/billing/return',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGoalsIndexRoute = AuthenticatedGoalsIndexRouteImport.update({
  id: '/goals/',
  path: '/goals/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGoalsGoalIdRoute =
  AuthenticatedGoalsGoalIdRouteImport.update({
    id: '/goals/$goalId',
    path: '/goals/$goalId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInsightsIndexRoute =
  AuthenticatedInsightsIndexRouteImport.update({
    id: '/insights/',
    path: '/insights/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsBillingRoute =
  AuthenticatedSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsConnectionsRoute =
  AuthenticatedSettingsConnectionsRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsSecurityRoute =
  AuthenticatedSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsTeamRoute =
  AuthenticatedSettingsTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedStrategiesIndexRoute =
  AuthenticatedStrategiesIndexRouteImport.update({
    id: '/strategies/',
    path: '/strategies/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStrategiesStrategyIdRoute =
  AuthenticatedStrategiesStrategyIdRouteImport.update({
    id: '/strategies/$strategyId',
    path: '/strategies/$strategyId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWizardIndexRoute =
  AuthenticatedWizardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWizardRoute,
  } as any)
const AuthenticatedWizardBriefRoute =
  AuthenticatedWizardBriefRouteImport.update({
    id: '/brief',
    path: '/brief',
    getParentRoute: () => AuthenticatedWizardRoute,
  } as any)
const AuthenticatedWizardLaunchedRoute =
  AuthenticatedWizardLaunchedRouteImport.update({
    id: '/launched',
    path: '/launched',
    getParentRoute: () => AuthenticatedWizardRoute,
  } as any)
const AuthenticatedAdminAiQualityIndexRoute =
  AuthenticatedAdminAiQualityIndexRouteImport.update({
    id: '/ai-quality/',
    path: '/ai-quality/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAuditReportsIndexRoute =
  AuthenticatedAdminAuditReportsIndexRouteImport.update({
    id: '/audit-reports/',
    path: '/audit-reports/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAuditReportsIntakeIdRoute =
  AuthenticatedAdminAuditReportsIntakeIdRouteImport.update({
    id: '/audit-reports/$intakeId',
    path: '/audit-reports/$intakeId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminJobsIndexRoute =
  AuthenticatedAdminJobsIndexRouteImport.update({
    id: '/jobs/',
    path: '/jobs/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminJobsJobIdRoute =
  AuthenticatedAdminJobsJobIdRouteImport.update({
    id: '/jobs/$jobId',
    path: '/jobs/$jobId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminLlmUsageIndexRoute =
  AuthenticatedAdminLlmUsageIndexRouteImport.update({
    id: '/llm-usage/',
    path: '/llm-usage/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminLlmUsageOrgIdRoute =
  AuthenticatedAdminLlmUsageOrgIdRouteImport.update({
    id: '/llm-usage/$orgId',
    path: '/llm-usage/$orgId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminOrganizationsIndexRoute =
  AuthenticatedAdminOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminOrganizationsOrgIdRoute =
  AuthenticatedAdminOrganizationsOrgIdRouteImport.update({
    id: '/organizations/$orgId',
    path: '/organizations/$orgId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminUsersIndexRoute =
  AuthenticatedAdminUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminUsersUserIdRoute =
  AuthenticatedAdminUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAgencySettingsIndexRoute =
  AuthenticatedAgencySettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAgencySettingsRoute,
  } as any)
const AuthenticatedAgencySettingsNotificationsRoute =
  AuthenticatedAgencySettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedAgencySettingsRoute,
  } as any)
const AuthenticatedAgencySettingsSecurityRoute =
  AuthenticatedAgencySettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedAgencySettingsRoute,
  } as any)
const AuthenticatedStrategiesStrategyIdIndexRoute =
  AuthenticatedStrategiesStrategyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedStrategiesStrategyIdRoute,
  } as any)
const AuthenticatedWizardCampaignsStrategyIdRoute =
  AuthenticatedWizardCampaignsStrategyIdRouteImport.update({
    id: '/campaigns/$strategyId',
    path: '/campaigns/$strategyId',
    getParentRoute: () => AuthenticatedWizardRoute,
  } as any)
const AuthenticatedWizardPlanStrategyIdRoute =
  AuthenticatedWizardPlanStrategyIdRouteImport.update({
    id: '/plan/$strategyId',
    path: '/plan/$strategyId',
    getParentRoute: () => AuthenticatedWizardRoute,
  } as any)
const AuthenticatedStrategiesStrategyIdCampaignsCampaignIdRoute =
  AuthenticatedStrategiesStrategyIdCampaignsCampaignIdRouteImport.update({
    id: '/campaigns/$campaignId',
    path: '/campaigns/$campaignId',
    getParentRoute: () => AuthenticatedStrategiesStrategyIdRoute,
  } as any)
const AuthenticatedWizardCampaignsStrategyIdIndexRoute =
  AuthenticatedWizardCampaignsStrategyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWizardCampaignsStrategyIdRoute,
  } as any)
const AuthenticatedWizardCampaignsStrategyIdCampaignIndexRoute =
  AuthenticatedWizardCampaignsStrategyIdCampaignIndexRouteImport.update({
    id: '/$campaignIndex',
    path: '/$campaignIndex',
    getParentRoute: () => AuthenticatedWizardCampaignsStrategyIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/data-deletion': typeof DataDeletionRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/assets': typeof AuthenticatedAssetsRouteWithChildren
  '/connect-ga4-property': typeof AuthenticatedConnectGa4PropertyRoute
  '/connect-google-account': typeof AuthenticatedConnectGoogleAccountRoute
  '/connect-gtm-container': typeof AuthenticatedConnectGtmContainerRoute
  '/connect-meta-assets': typeof AuthenticatedConnectMetaAssetsRoute
  '/connect-platforms': typeof AuthenticatedConnectPlatformsRoute
  '/connectors': typeof AuthenticatedConnectorsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/extend-trial': typeof AuthenticatedExtendTrialRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/organization-setup': typeof AuthenticatedOrganizationSetupRoute
  '/paywall': typeof AuthenticatedPaywallRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/support': typeof AuthenticatedSupportRoute
  '/wizard': typeof AuthenticatedWizardRouteWithChildren
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/signup': typeof PublicSignupRoute
  '/verify-email': typeof PublicVerifyEmailRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/admin/audit': typeof AuthenticatedAdminAuditRoute
  '/admin/integrations': typeof AuthenticatedAdminIntegrationsRoute
  '/admin/invitations': typeof AuthenticatedAdminInvitationsRoute
  '/admin/managed-spend': typeof AuthenticatedAdminManagedSpendRoute
  '/admin/system': typeof AuthenticatedAdminSystemRoute
  '/admin/user-analytics': typeof AuthenticatedAdminUserAnalyticsRoute
  '/agency/billing': typeof AuthenticatedAgencyBillingRoute
  '/agency/clients': typeof AuthenticatedAgencyClientsRoute
  '/agency/connections': typeof AuthenticatedAgencyConnectionsRoute
  '/agency/onboarding': typeof AuthenticatedAgencyOnboardingRoute
  '/agency/settings': typeof AuthenticatedAgencySettingsRouteWithChildren
  '/agency/setup': typeof AuthenticatedAgencySetupRoute
  '/agency/team': typeof AuthenticatedAgencyTeamRoute
  '/assets/$assetId': typeof AuthenticatedAssetsAssetIdRoute
  '/audiences/$audienceId': typeof AuthenticatedAudiencesAudienceIdRoute
  '/billing/return': typeof AuthenticatedBillingReturnRoute
  '/goals/$goalId': typeof AuthenticatedGoalsGoalIdRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/settings/connections': typeof AuthenticatedSettingsConnectionsRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/settings/team': typeof AuthenticatedSettingsTeamRoute
  '/strategies/$strategyId': typeof AuthenticatedStrategiesStrategyIdRouteWithChildren
  '/wizard/brief': typeof AuthenticatedWizardBriefRoute
  '/wizard/launched': typeof AuthenticatedWizardLaunchedRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/agency/': typeof AuthenticatedAgencyIndexRoute
  '/ai-performance/': typeof AuthenticatedAiPerformanceIndexRoute
  '/assets/': typeof AuthenticatedAssetsIndexRoute
  '/audiences/': typeof AuthenticatedAudiencesIndexRoute
  '/goals/': typeof AuthenticatedGoalsIndexRoute
  '/insights/': typeof AuthenticatedInsightsIndexRoute
  '/reports/': typeof AuthenticatedReportsIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/strategies/': typeof AuthenticatedStrategiesIndexRoute
  '/wizard/': typeof AuthenticatedWizardIndexRoute
  '/admin/audit-reports/$intakeId': typeof AuthenticatedAdminAuditReportsIntakeIdRoute
  '/admin/jobs/$jobId': typeof AuthenticatedAdminJobsJobIdRoute
  '/admin/llm-usage/$orgId': typeof AuthenticatedAdminLlmUsageOrgIdRoute
  '/admin/organizations/$orgId': typeof AuthenticatedAdminOrganizationsOrgIdRoute
  '/admin/users/$userId': typeof AuthenticatedAdminUsersUserIdRoute
  '/agency/settings/notifications': typeof AuthenticatedAgencySettingsNotificationsRoute
  '/agency/settings/security': typeof AuthenticatedAgencySettingsSecurityRoute
  '/wizard/campaigns/$strategyId': typeof AuthenticatedWizardCampaignsStrategyIdRouteWithChildren
  '/wizard/plan/$strategyId': typeof AuthenticatedWizardPlanStrategyIdRoute
  '/admin/ai-quality/': typeof AuthenticatedAdminAiQualityIndexRoute
  '/admin/audit-reports/': typeof AuthenticatedAdminAuditReportsIndexRoute
  '/admin/jobs/': typeof AuthenticatedAdminJobsIndexRoute
  '/admin/llm-usage/': typeof AuthenticatedAdminLlmUsageIndexRoute
  '/admin/organizations/': typeof AuthenticatedAdminOrganizationsIndexRoute
  '/admin/users/': typeof AuthenticatedAdminUsersIndexRoute
  '/agency/settings/': typeof AuthenticatedAgencySettingsIndexRoute
  '/strategies/$strategyId/': typeof AuthenticatedStrategiesStrategyIdIndexRoute
  '/strategies/$strategyId/campaigns/$campaignId': typeof AuthenticatedStrategiesStrategyIdCampaignsCampaignIdRoute
  '/wizard/campaigns/$strategyId/$campaignIndex': typeof AuthenticatedWizardCampaignsStrategyIdCampaignIndexRoute
  '/wizard/campaigns/$strategyId/': typeof AuthenticatedWizardCampaignsStrategyIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/data-deletion': typeof DataDeletionRoute
  '/connect-ga4-property': typeof AuthenticatedConnectGa4PropertyRoute
  '/connect-google-account': typeof AuthenticatedConnectGoogleAccountRoute
  '/connect-gtm-container': typeof AuthenticatedConnectGtmContainerRoute
  '/connect-meta-assets': typeof AuthenticatedConnectMetaAssetsRoute
  '/connect-platforms': typeof AuthenticatedConnectPlatformsRoute
  '/connectors': typeof AuthenticatedConnectorsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/extend-trial': typeof AuthenticatedExtendTrialRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/organization-setup': typeof AuthenticatedOrganizationSetupRoute
  '/paywall': typeof AuthenticatedPaywallRoute
  '/support': typeof AuthenticatedSupportRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/signup': typeof PublicSignupRoute
  '/verify-email': typeof PublicVerifyEmailRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/admin/audit': typeof AuthenticatedAdminAuditRoute
  '/admin/integrations': typeof AuthenticatedAdminIntegrationsRoute
  '/admin/invitations': typeof AuthenticatedAdminInvitationsRoute
  '/admin/managed-spend': typeof AuthenticatedAdminManagedSpendRoute
  '/admin/system': typeof AuthenticatedAdminSystemRoute
  '/admin/user-analytics': typeof AuthenticatedAdminUserAnalyticsRoute
  '/agency/billing': typeof AuthenticatedAgencyBillingRoute
  '/agency/clients': typeof AuthenticatedAgencyClientsRoute
  '/agency/connections': typeof AuthenticatedAgencyConnectionsRoute
  '/agency/onboarding': typeof AuthenticatedAgencyOnboardingRoute
  '/agency/setup': typeof AuthenticatedAgencySetupRoute
  '/agency/team': typeof AuthenticatedAgencyTeamRoute
  '/assets/$assetId': typeof AuthenticatedAssetsAssetIdRoute
  '/audiences/$audienceId': typeof AuthenticatedAudiencesAudienceIdRoute
  '/billing/return': typeof AuthenticatedBillingReturnRoute
  '/goals/$goalId': typeof AuthenticatedGoalsGoalIdRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/settings/connections': typeof AuthenticatedSettingsConnectionsRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/settings/team': typeof AuthenticatedSettingsTeamRoute
  '/wizard/brief': typeof AuthenticatedWizardBriefRoute
  '/wizard/launched': typeof AuthenticatedWizardLaunchedRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/agency': typeof AuthenticatedAgencyIndexRoute
  '/ai-performance': typeof AuthenticatedAiPerformanceIndexRoute
  '/assets': typeof AuthenticatedAssetsIndexRoute
  '/audiences': typeof AuthenticatedAudiencesIndexRoute
  '/goals': typeof AuthenticatedGoalsIndexRoute
  '/insights': typeof AuthenticatedInsightsIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/strategies': typeof AuthenticatedStrategiesIndexRoute
  '/wizard': typeof AuthenticatedWizardIndexRoute
  '/admin/audit-reports/$intakeId': typeof AuthenticatedAdminAuditReportsIntakeIdRoute
  '/admin/jobs/$jobId': typeof AuthenticatedAdminJobsJobIdRoute
  '/admin/llm-usage/$orgId': typeof AuthenticatedAdminLlmUsageOrgIdRoute
  '/admin/organizations/$orgId': typeof AuthenticatedAdminOrganizationsOrgIdRoute
  '/admin/users/$userId': typeof AuthenticatedAdminUsersUserIdRoute
  '/agency/settings/notifications': typeof AuthenticatedAgencySettingsNotificationsRoute
  '/agency/settings/security': typeof AuthenticatedAgencySettingsSecurityRoute
  '/wizard/plan/$strategyId': typeof AuthenticatedWizardPlanStrategyIdRoute
  '/admin/ai-quality': typeof AuthenticatedAdminAiQualityIndexRoute
  '/admin/audit-reports': typeof AuthenticatedAdminAuditReportsIndexRoute
  '/admin/jobs': typeof AuthenticatedAdminJobsIndexRoute
  '/admin/llm-usage': typeof AuthenticatedAdminLlmUsageIndexRoute
  '/admin/organizations': typeof AuthenticatedAdminOrganizationsIndexRoute
  '/admin/users': typeof AuthenticatedAdminUsersIndexRoute
  '/agency/settings': typeof AuthenticatedAgencySettingsIndexRoute
  '/strategies/$strategyId': typeof AuthenticatedStrategiesStrategyIdIndexRoute
  '/strategies/$strategyId/campaigns/$campaignId': typeof AuthenticatedStrategiesStrategyIdCampaignsCampaignIdRoute
  '/wizard/campaigns/$strategyId/$campaignIndex': typeof AuthenticatedWizardCampaignsStrategyIdCampaignIndexRoute
  '/wizard/campaigns/$strategyId': typeof AuthenticatedWizardCampaignsStrategyIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/data-deletion': typeof DataDeletionRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/assets': typeof AuthenticatedAssetsRouteWithChildren
  '/_authenticated/connect-ga4-property': typeof AuthenticatedConnectGa4PropertyRoute
  '/_authenticated/connect-google-account': typeof AuthenticatedConnectGoogleAccountRoute
  '/_authenticated/connect-gtm-container': typeof AuthenticatedConnectGtmContainerRoute
  '/_authenticated/connect-meta-assets': typeof AuthenticatedConnectMetaAssetsRoute
  '/_authenticated/connect-platforms': typeof AuthenticatedConnectPlatformsRoute
  '/_authenticated/connectors': typeof AuthenticatedConnectorsRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/extend-trial': typeof AuthenticatedExtendTrialRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/organization-setup': typeof AuthenticatedOrganizationSetupRoute
  '/_authenticated/paywall': typeof AuthenticatedPaywallRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/support': typeof AuthenticatedSupportRoute
  '/_authenticated/wizard': typeof AuthenticatedWizardRouteWithChildren
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/signup': typeof PublicSignupRoute
  '/_public/verify-email': typeof PublicVerifyEmailRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_authenticated/admin/audit': typeof AuthenticatedAdminAuditRoute
  '/_authenticated/admin/integrations': typeof AuthenticatedAdminIntegrationsRoute
  '/_authenticated/admin/invitations': typeof AuthenticatedAdminInvitationsRoute
  '/_authenticated/admin/managed-spend': typeof AuthenticatedAdminManagedSpendRoute
  '/_authenticated/admin/system': typeof AuthenticatedAdminSystemRoute
  '/_authenticated/admin/user-analytics': typeof AuthenticatedAdminUserAnalyticsRoute
  '/_authenticated/agency/billing': typeof AuthenticatedAgencyBillingRoute
  '/_authenticated/agency/clients': typeof AuthenticatedAgencyClientsRoute
  '/_authenticated/agency/connections': typeof AuthenticatedAgencyConnectionsRoute
  '/_authenticated/agency/onboarding': typeof AuthenticatedAgencyOnboardingRoute
  '/_authenticated/agency/settings': typeof AuthenticatedAgencySettingsRouteWithChildren
  '/_authenticated/agency/setup': typeof AuthenticatedAgencySetupRoute
  '/_authenticated/agency/team': typeof AuthenticatedAgencyTeamRoute
  '/_authenticated/assets/$assetId': typeof AuthenticatedAssetsAssetIdRoute
  '/_authenticated/audiences/$audienceId': typeof AuthenticatedAudiencesAudienceIdRoute
  '/_authenticated/billing/return': typeof AuthenticatedBillingReturnRoute
  '/_authenticated/goals/$goalId': typeof AuthenticatedGoalsGoalIdRoute
  '/_authenticated/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/_authenticated/settings/connections': typeof AuthenticatedSettingsConnectionsRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/_authenticated/settings/team': typeof AuthenticatedSettingsTeamRoute
  '/_authenticated/strategies/$strategyId': typeof AuthenticatedStrategiesStrategyIdRouteWithChildren
  '/_authenticated/wizard/brief': typeof AuthenticatedWizardBriefRoute
  '/_authenticated/wizard/launched': typeof AuthenticatedWizardLaunchedRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/agency/': typeof AuthenticatedAgencyIndexRoute
  '/_authenticated/ai-performance/': typeof AuthenticatedAiPerformanceIndexRoute
  '/_authenticated/assets/': typeof AuthenticatedAssetsIndexRoute
  '/_authenticated/audiences/': typeof AuthenticatedAudiencesIndexRoute
  '/_authenticated/goals/': typeof AuthenticatedGoalsIndexRoute
  '/_authenticated/insights/': typeof AuthenticatedInsightsIndexRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/strategies/': typeof AuthenticatedStrategiesIndexRoute
  '/_authenticated/wizard/': typeof AuthenticatedWizardIndexRoute
  '/_authenticated/admin/audit-reports/$intakeId': typeof AuthenticatedAdminAuditReportsIntakeIdRoute
  '/_authenticated/admin/jobs/$jobId': typeof AuthenticatedAdminJobsJobIdRoute
  '/_authenticated/admin/llm-usage/$orgId': typeof AuthenticatedAdminLlmUsageOrgIdRoute
  '/_authenticated/admin/organizations/$orgId': typeof AuthenticatedAdminOrganizationsOrgIdRoute
  '/_authenticated/admin/users/$userId': typeof AuthenticatedAdminUsersUserIdRoute
  '/_authenticated/agency/settings/notifications': typeof AuthenticatedAgencySettingsNotificationsRoute
  '/_authenticated/agency/settings/security': typeof AuthenticatedAgencySettingsSecurityRoute
  '/_authenticated/wizard/campaigns/$strategyId': typeof AuthenticatedWizardCampaignsStrategyIdRouteWithChildren
  '/_authenticated/wizard/plan/$strategyId': typeof AuthenticatedWizardPlanStrategyIdRoute
  '/_authenticated/admin/ai-quality/': typeof AuthenticatedAdminAiQualityIndexRoute
  '/_authenticated/admin/audit-reports/': typeof AuthenticatedAdminAuditReportsIndexRoute
  '/_authenticated/admin/jobs/': typeof AuthenticatedAdminJobsIndexRoute
  '/_authenticated/admin/llm-usage/': typeof AuthenticatedAdminLlmUsageIndexRoute
  '/_authenticated/admin/organizations/': typeof AuthenticatedAdminOrganizationsIndexRoute
  '/_authenticated/admin/users/': typeof AuthenticatedAdminUsersIndexRoute
  '/_authenticated/agency/settings/': typeof AuthenticatedAgencySettingsIndexRoute
  '/_authenticated/strategies/$strategyId/': typeof AuthenticatedStrategiesStrategyIdIndexRoute
  '/_authenticated/strategies/$strategyId/campaigns/$campaignId': typeof AuthenticatedStrategiesStrategyIdCampaignsCampaignIdRoute
  '/_authenticated/wizard/campaigns/$strategyId/$campaignIndex': typeof AuthenticatedWizardCampaignsStrategyIdCampaignIndexRoute
  '/_authenticated/wizard/campaigns/$strategyId/': typeof AuthenticatedWizardCampaignsStrategyIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/data-deletion'
    | '/admin'
    | '/assets'
    | '/connect-ga4-property'
    | '/connect-google-account'
    | '/connect-gtm-container'
    | '/connect-meta-assets'
    | '/connect-platforms'
    | '/connectors'
    | '/dashboard'
    | '/extend-trial'
    | '/notifications'
    | '/organization-setup'
    | '/paywall'
    | '/settings'
    | '/support'
    | '/wizard'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/auth/callback'
    | '/admin/audit'
    | '/admin/integrations'
    | '/admin/invitations'
    | '/admin/managed-spend'
    | '/admin/system'
    | '/admin/user-analytics'
    | '/agency/billing'
    | '/agency/clients'
    | '/agency/connections'
    | '/agency/onboarding'
    | '/agency/settings'
    | '/agency/setup'
    | '/agency/team'
    | '/assets/$assetId'
    | '/audiences/$audienceId'
    | '/billing/return'
    | '/goals/$goalId'
    | '/settings/billing'
    | '/settings/connections'
    | '/settings/notifications'
    | '/settings/security'
    | '/settings/team'
    | '/strategies/$strategyId'
    | '/wizard/brief'
    | '/wizard/launched'
    | '/admin/'
    | '/agency/'
    | '/ai-performance/'
    | '/assets/'
    | '/audiences/'
    | '/goals/'
    | '/insights/'
    | '/reports/'
    | '/settings/'
    | '/strategies/'
    | '/wizard/'
    | '/admin/audit-reports/$intakeId'
    | '/admin/jobs/$jobId'
    | '/admin/llm-usage/$orgId'
    | '/admin/organizations/$orgId'
    | '/admin/users/$userId'
    | '/agency/settings/notifications'
    | '/agency/settings/security'
    | '/wizard/campaigns/$strategyId'
    | '/wizard/plan/$strategyId'
    | '/admin/ai-quality/'
    | '/admin/audit-reports/'
    | '/admin/jobs/'
    | '/admin/llm-usage/'
    | '/admin/organizations/'
    | '/admin/users/'
    | '/agency/settings/'
    | '/strategies/$strategyId/'
    | '/strategies/$strategyId/campaigns/$campaignId'
    | '/wizard/campaigns/$strategyId/$campaignIndex'
    | '/wizard/campaigns/$strategyId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/data-deletion'
    | '/connect-ga4-property'
    | '/connect-google-account'
    | '/connect-gtm-container'
    | '/connect-meta-assets'
    | '/connect-platforms'
    | '/connectors'
    | '/dashboard'
    | '/extend-trial'
    | '/notifications'
    | '/organization-setup'
    | '/paywall'
    | '/support'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/auth/callback'
    | '/admin/audit'
    | '/admin/integrations'
    | '/admin/invitations'
    | '/admin/managed-spend'
    | '/admin/system'
    | '/admin/user-analytics'
    | '/agency/billing'
    | '/agency/clients'
    | '/agency/connections'
    | '/agency/onboarding'
    | '/agency/setup'
    | '/agency/team'
    | '/assets/$assetId'
    | '/audiences/$audienceId'
    | '/billing/return'
    | '/goals/$goalId'
    | '/settings/billing'
    | '/settings/connections'
    | '/settings/notifications'
    | '/settings/security'
    | '/settings/team'
    | '/wizard/brief'
    | '/wizard/launched'
    | '/admin'
    | '/agency'
    | '/ai-performance'
    | '/assets'
    | '/audiences'
    | '/goals'
    | '/insights'
    | '/reports'
    | '/settings'
    | '/strategies'
    | '/wizard'
    | '/admin/audit-reports/$intakeId'
    | '/admin/jobs/$jobId'
    | '/admin/llm-usage/$orgId'
    | '/admin/organizations/$orgId'
    | '/admin/users/$userId'
    | '/agency/settings/notifications'
    | '/agency/settings/security'
    | '/wizard/plan/$strategyId'
    | '/admin/ai-quality'
    | '/admin/audit-reports'
    | '/admin/jobs'
    | '/admin/llm-usage'
    | '/admin/organizations'
    | '/admin/users'
    | '/agency/settings'
    | '/strategies/$strategyId'
    | '/strategies/$strategyId/campaigns/$campaignId'
    | '/wizard/campaigns/$strategyId/$campaignIndex'
    | '/wizard/campaigns/$strategyId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_public'
    | '/data-deletion'
    | '/_authenticated/admin'
    | '/_authenticated/assets'
    | '/_authenticated/connect-ga4-property'
    | '/_authenticated/connect-google-account'
    | '/_authenticated/connect-gtm-container'
    | '/_authenticated/connect-meta-assets'
    | '/_authenticated/connect-platforms'
    | '/_authenticated/connectors'
    | '/_authenticated/dashboard'
    | '/_authenticated/extend-trial'
    | '/_authenticated/notifications'
    | '/_authenticated/organization-setup'
    | '/_authenticated/paywall'
    | '/_authenticated/settings'
    | '/_authenticated/support'
    | '/_authenticated/wizard'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_public/reset-password'
    | '/_public/signup'
    | '/_public/verify-email'
    | '/auth/callback'
    | '/_authenticated/admin/audit'
    | '/_authenticated/admin/integrations'
    | '/_authenticated/admin/invitations'
    | '/_authenticated/admin/managed-spend'
    | '/_authenticated/admin/system'
    | '/_authenticated/admin/user-analytics'
    | '/_authenticated/agency/billing'
    | '/_authenticated/agency/clients'
    | '/_authenticated/agency/connections'
    | '/_authenticated/agency/onboarding'
    | '/_authenticated/agency/settings'
    | '/_authenticated/agency/setup'
    | '/_authenticated/agency/team'
    | '/_authenticated/assets/$assetId'
    | '/_authenticated/audiences/$audienceId'
    | '/_authenticated/billing/return'
    | '/_authenticated/goals/$goalId'
    | '/_authenticated/settings/billing'
    | '/_authenticated/settings/connections'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/security'
    | '/_authenticated/settings/team'
    | '/_authenticated/strategies/$strategyId'
    | '/_authenticated/wizard/brief'
    | '/_authenticated/wizard/launched'
    | '/_authenticated/admin/'
    | '/_authenticated/agency/'
    | '/_authenticated/ai-performance/'
    | '/_authenticated/assets/'
    | '/_authenticated/audiences/'
    | '/_authenticated/goals/'
    | '/_authenticated/insights/'
    | '/_authenticated/reports/'
    | '/_authenticated/settings/'
    | '/_authenticated/strategies/'
    | '/_authenticated/wizard/'
    | '/_authenticated/admin/audit-reports/$intakeId'
    | '/_authenticated/admin/jobs/$jobId'
    | '/_authenticated/admin/llm-usage/$orgId'
    | '/_authenticated/admin/organizations/$orgId'
    | '/_authenticated/admin/users/$userId'
    | '/_authenticated/agency/settings/notifications'
    | '/_authenticated/agency/settings/security'
    | '/_authenticated/wizard/campaigns/$strategyId'
    | '/_authenticated/wizard/plan/$strategyId'
    | '/_authenticated/admin/ai-quality/'
    | '/_authenticated/admin/audit-reports/'
    | '/_authenticated/admin/jobs/'
    | '/_authenticated/admin/llm-usage/'
    | '/_authenticated/admin/organizations/'
    | '/_authenticated/admin/users/'
    | '/_authenticated/agency/settings/'
    | '/_authenticated/strategies/$strategyId/'
    | '/_authenticated/strategies/$strategyId/campaigns/$campaignId'
    | '/_authenticated/wizard/campaigns/$strategyId/$campaignIndex'
    | '/_authenticated/wizard/campaigns/$strategyId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  DataDeletionRoute: typeof DataDeletionRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-deletion': {
      id: '/data-deletion'
      path: '/data-deletion'
      fullPath: '/data-deletion'
      preLoaderRoute: typeof DataDeletionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assets': {
      id: '/_authenticated/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AuthenticatedAssetsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/connect-ga4-property': {
      id: '/_authenticated/connect-ga4-property'
      path: '/connect-ga4-property'
      fullPath: '/connect-ga4-property'
      preLoaderRoute: typeof AuthenticatedConnectGa4PropertyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/connect-google-account': {
      id: '/_authenticated/connect-google-account'
      path: '/connect-google-account'
      fullPath: '/connect-google-account'
      preLoaderRoute: typeof AuthenticatedConnectGoogleAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/connect-gtm-container': {
      id: '/_authenticated/connect-gtm-container'
      path: '/connect-gtm-container'
      fullPath: '/connect-gtm-container'
      preLoaderRoute: typeof AuthenticatedConnectGtmContainerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/connect-meta-assets': {
      id: '/_authenticated/connect-meta-assets'
      path: '/connect-meta-assets'
      fullPath: '/connect-meta-assets'
      preLoaderRoute: typeof AuthenticatedConnectMetaAssetsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/connect-platforms': {
      id: '/_authenticated/connect-platforms'
      path: '/connect-platforms'
      fullPath: '/connect-platforms'
      preLoaderRoute: typeof AuthenticatedConnectPlatformsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/connectors': {
      id: '/_authenticated/connectors'
      path: '/connectors'
      fullPath: '/connectors'
      preLoaderRoute: typeof AuthenticatedConnectorsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/extend-trial': {
      id: '/_authenticated/extend-trial'
      path: '/extend-trial'
      fullPath: '/extend-trial'
      preLoaderRoute: typeof AuthenticatedExtendTrialRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organization-setup': {
      id: '/_authenticated/organization-setup'
      path: '/organization-setup'
      fullPath: '/organization-setup'
      preLoaderRoute: typeof AuthenticatedOrganizationSetupRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/paywall': {
      id: '/_authenticated/paywall'
      path: '/paywall'
      fullPath: '/paywall'
      preLoaderRoute: typeof AuthenticatedPaywallRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/support': {
      id: '/_authenticated/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthenticatedSupportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/wizard': {
      id: '/_authenticated/wizard'
      path: '/wizard'
      fullPath: '/wizard'
      preLoaderRoute: typeof AuthenticatedWizardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/signup': {
      id: '/_public/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof PublicSignupRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/verify-email': {
      id: '/_public/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof PublicVerifyEmailRouteImport
      parentRoute: typeof PublicRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/audit': {
      id: '/_authenticated/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AuthenticatedAdminAuditRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/integrations': {
      id: '/_authenticated/admin/integrations'
      path: '/integrations'
      fullPath: '/admin/integrations'
      preLoaderRoute: typeof AuthenticatedAdminIntegrationsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/invitations': {
      id: '/_authenticated/admin/invitations'
      path: '/invitations'
      fullPath: '/admin/invitations'
      preLoaderRoute: typeof AuthenticatedAdminInvitationsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/managed-spend': {
      id: '/_authenticated/admin/managed-spend'
      path: '/managed-spend'
      fullPath: '/admin/managed-spend'
      preLoaderRoute: typeof AuthenticatedAdminManagedSpendRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/system': {
      id: '/_authenticated/admin/system'
      path: '/system'
      fullPath: '/admin/system'
      preLoaderRoute: typeof AuthenticatedAdminSystemRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/user-analytics': {
      id: '/_authenticated/admin/user-analytics'
      path: '/user-analytics'
      fullPath: '/admin/user-analytics'
      preLoaderRoute: typeof AuthenticatedAdminUserAnalyticsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/agency/': {
      id: '/_authenticated/agency/'
      path: '/agency'
      fullPath: '/agency/'
      preLoaderRoute: typeof AuthenticatedAgencyIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agency/billing': {
      id: '/_authenticated/agency/billing'
      path: '/agency/billing'
      fullPath: '/agency/billing'
      preLoaderRoute: typeof AuthenticatedAgencyBillingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agency/clients': {
      id: '/_authenticated/agency/clients'
      path: '/agency/clients'
      fullPath: '/agency/clients'
      preLoaderRoute: typeof AuthenticatedAgencyClientsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agency/connections': {
      id: '/_authenticated/agency/connections'
      path: '/agency/connections'
      fullPath: '/agency/connections'
      preLoaderRoute: typeof AuthenticatedAgencyConnectionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agency/onboarding': {
      id: '/_authenticated/agency/onboarding'
      path: '/agency/onboarding'
      fullPath: '/agency/onboarding'
      preLoaderRoute: typeof AuthenticatedAgencyOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agency/settings': {
      id: '/_authenticated/agency/settings'
      path: '/agency/settings'
      fullPath: '/agency/settings'
      preLoaderRoute: typeof AuthenticatedAgencySettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agency/setup': {
      id: '/_authenticated/agency/setup'
      path: '/agency/setup'
      fullPath: '/agency/setup'
      preLoaderRoute: typeof AuthenticatedAgencySetupRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agency/team': {
      id: '/_authenticated/agency/team'
      path: '/agency/team'
      fullPath: '/agency/team'
      preLoaderRoute: typeof AuthenticatedAgencyTeamRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai-performance/': {
      id: '/_authenticated/ai-performance/'
      path: '/ai-performance'
      fullPath: '/ai-performance/'
      preLoaderRoute: typeof AuthenticatedAiPerformanceIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assets/': {
      id: '/_authenticated/assets/'
      path: '/'
      fullPath: '/assets/'
      preLoaderRoute: typeof AuthenticatedAssetsIndexRouteImport
      parentRoute: typeof AuthenticatedAssetsRoute
    }
    '/_authenticated/assets/$assetId': {
      id: '/_authenticated/assets/$assetId'
      path: '/$assetId'
      fullPath: '/assets/$assetId'
      preLoaderRoute: typeof AuthenticatedAssetsAssetIdRouteImport
      parentRoute: typeof AuthenticatedAssetsRoute
    }
    '/_authenticated/audiences/': {
      id: '/_authenticated/audiences/'
      path: '/audiences'
      fullPath: '/audiences/'
      preLoaderRoute: typeof AuthenticatedAudiencesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audiences/$audienceId': {
      id: '/_authenticated/audiences/$audienceId'
      path: '/audiences/$audienceId'
      fullPath: '/audiences/$audienceId'
      preLoaderRoute: typeof AuthenticatedAudiencesAudienceIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/billing/return': {
      id: '/_authenticated/billing/return'
      path: '/billing/return'
      fullPath: '/billing/return'
      preLoaderRoute: typeof AuthenticatedBillingReturnRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/goals/': {
      id: '/_authenticated/goals/'
      path: '/goals'
      fullPath: '/goals/'
      preLoaderRoute: typeof AuthenticatedGoalsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/goals/$goalId': {
      id: '/_authenticated/goals/$goalId'
      path: '/goals/$goalId'
      fullPath: '/goals/$goalId'
      preLoaderRoute: typeof AuthenticatedGoalsGoalIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/insights/': {
      id: '/_authenticated/insights/'
      path: '/insights'
      fullPath: '/insights/'
      preLoaderRoute: typeof AuthenticatedInsightsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/billing': {
      id: '/_authenticated/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedSettingsBillingRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/connections': {
      id: '/_authenticated/settings/connections'
      path: '/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof AuthenticatedSettingsConnectionsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/security': {
      id: '/_authenticated/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthenticatedSettingsSecurityRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/team': {
      id: '/_authenticated/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AuthenticatedSettingsTeamRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/strategies/': {
      id: '/_authenticated/strategies/'
      path: '/strategies'
      fullPath: '/strategies/'
      preLoaderRoute: typeof AuthenticatedStrategiesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/strategies/$strategyId': {
      id: '/_authenticated/strategies/$strategyId'
      path: '/strategies/$strategyId'
      fullPath: '/strategies/$strategyId'
      preLoaderRoute: typeof AuthenticatedStrategiesStrategyIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/wizard/': {
      id: '/_authenticated/wizard/'
      path: '/'
      fullPath: '/wizard/'
      preLoaderRoute: typeof AuthenticatedWizardIndexRouteImport
      parentRoute: typeof AuthenticatedWizardRoute
    }
    '/_authenticated/wizard/brief': {
      id: '/_authenticated/wizard/brief'
      path: '/brief'
      fullPath: '/wizard/brief'
      preLoaderRoute: typeof AuthenticatedWizardBriefRouteImport
      parentRoute: typeof AuthenticatedWizardRoute
    }
    '/_authenticated/wizard/launched': {
      id: '/_authenticated/wizard/launched'
      path: '/launched'
      fullPath: '/wizard/launched'
      preLoaderRoute: typeof AuthenticatedWizardLaunchedRouteImport
      parentRoute: typeof AuthenticatedWizardRoute
    }
    '/_authenticated/admin/ai-quality/': {
      id: '/_authenticated/admin/ai-quality/'
      path: '/ai-quality'
      fullPath: '/admin/ai-quality/'
      preLoaderRoute: typeof AuthenticatedAdminAiQualityIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/audit-reports/': {
      id: '/_authenticated/admin/audit-reports/'
      path: '/audit-reports'
      fullPath: '/admin/audit-reports/'
      preLoaderRoute: typeof AuthenticatedAdminAuditReportsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/audit-reports/$intakeId': {
      id: '/_authenticated/admin/audit-reports/$intakeId'
      path: '/audit-reports/$intakeId'
      fullPath: '/admin/audit-reports/$intakeId'
      preLoaderRoute: typeof AuthenticatedAdminAuditReportsIntakeIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/jobs/': {
      id: '/_authenticated/admin/jobs/'
      path: '/jobs'
      fullPath: '/admin/jobs/'
      preLoaderRoute: typeof AuthenticatedAdminJobsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/jobs/$jobId': {
      id: '/_authenticated/admin/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/admin/jobs/$jobId'
      preLoaderRoute: typeof AuthenticatedAdminJobsJobIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/llm-usage/': {
      id: '/_authenticated/admin/llm-usage/'
      path: '/llm-usage'
      fullPath: '/admin/llm-usage/'
      preLoaderRoute: typeof AuthenticatedAdminLlmUsageIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/llm-usage/$orgId': {
      id: '/_authenticated/admin/llm-usage/$orgId'
      path: '/llm-usage/$orgId'
      fullPath: '/admin/llm-usage/$orgId'
      preLoaderRoute: typeof AuthenticatedAdminLlmUsageOrgIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/organizations/': {
      id: '/_authenticated/admin/organizations/'
      path: '/organizations'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/organizations/$orgId': {
      id: '/_authenticated/admin/organizations/$orgId'
      path: '/organizations/$orgId'
      fullPath: '/admin/organizations/$orgId'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsOrgIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/users/': {
      id: '/_authenticated/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AuthenticatedAdminUsersIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/users/$userId': {
      id: '/_authenticated/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AuthenticatedAdminUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/agency/settings/': {
      id: '/_authenticated/agency/settings/'
      path: '/'
      fullPath: '/agency/settings/'
      preLoaderRoute: typeof AuthenticatedAgencySettingsIndexRouteImport
      parentRoute: typeof AuthenticatedAgencySettingsRoute
    }
    '/_authenticated/agency/settings/notifications': {
      id: '/_authenticated/agency/settings/notifications'
      path: '/notifications'
      fullPath: '/agency/settings/notifications'
      preLoaderRoute: typeof AuthenticatedAgencySettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedAgencySettingsRoute
    }
    '/_authenticated/agency/settings/security': {
      id: '/_authenticated/agency/settings/security'
      path: '/security'
      fullPath: '/agency/settings/security'
      preLoaderRoute: typeof AuthenticatedAgencySettingsSecurityRouteImport
      parentRoute: typeof AuthenticatedAgencySettingsRoute
    }
    '/_authenticated/strategies/$strategyId/': {
      id: '/_authenticated/strategies/$strategyId/'
      path: '/'
      fullPath: '/strategies/$strategyId/'
      preLoaderRoute: typeof AuthenticatedStrategiesStrategyIdIndexRouteImport
      parentRoute: typeof AuthenticatedStrategiesStrategyIdRoute
    }
    '/_authenticated/wizard/campaigns/$strategyId': {
      id: '/_authenticated/wizard/campaigns/$strategyId'
      path: '/campaigns/$strategyId'
      fullPath: '/wizard/campaigns/$strategyId'
      preLoaderRoute: typeof AuthenticatedWizardCampaignsStrategyIdRouteImport
      parentRoute: typeof AuthenticatedWizardRoute
    }
    '/_authenticated/wizard/plan/$strategyId': {
      id: '/_authenticated/wizard/plan/$strategyId'
      path: '/plan/$strategyId'
      fullPath: '/wizard/plan/$strategyId'
      preLoaderRoute: typeof AuthenticatedWizardPlanStrategyIdRouteImport
      parentRoute: typeof AuthenticatedWizardRoute
    }
    '/_authenticated/strategies/$strategyId/campaigns/$campaignId': {
      id: '/_authenticated/strategies/$strategyId/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/strategies/$strategyId/campaigns/$campaignId'
      preLoaderRoute: typeof AuthenticatedStrategiesStrategyIdCampaignsCampaignIdRouteImport
      parentRoute: typeof AuthenticatedStrategiesStrategyIdRoute
    }
    '/_authenticated/wizard/campaigns/$strategyId/': {
      id: '/_authenticated/wizard/campaigns/$strategyId/'
      path: '/'
      fullPath: '/wizard/campaigns/$strategyId/'
      preLoaderRoute: typeof AuthenticatedWizardCampaignsStrategyIdIndexRouteImport
      parentRoute: typeof AuthenticatedWizardCampaignsStrategyIdRoute
    }
    '/_authenticated/wizard/campaigns/$strategyId/$campaignIndex': {
      id: '/_authenticated/wizard/campaigns/$strategyId/$campaignIndex'
      path: '/$campaignIndex'
      fullPath: '/wizard/campaigns/$strategyId/$campaignIndex'
      preLoaderRoute: typeof AuthenticatedWizardCampaignsStrategyIdCampaignIndexRouteImport
      parentRoute: typeof AuthenticatedWizardCampaignsStrategyIdRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminAuditRoute: typeof AuthenticatedAdminAuditRoute
  AuthenticatedAdminIntegrationsRoute: typeof AuthenticatedAdminIntegrationsRoute
  AuthenticatedAdminInvitationsRoute: typeof AuthenticatedAdminInvitationsRoute
  AuthenticatedAdminManagedSpendRoute: typeof AuthenticatedAdminManagedSpendRoute
  AuthenticatedAdminSystemRoute: typeof AuthenticatedAdminSystemRoute
  AuthenticatedAdminUserAnalyticsRoute: typeof AuthenticatedAdminUserAnalyticsRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminAuditReportsIntakeIdRoute: typeof AuthenticatedAdminAuditReportsIntakeIdRoute
  AuthenticatedAdminJobsJobIdRoute: typeof AuthenticatedAdminJobsJobIdRoute
  AuthenticatedAdminLlmUsageOrgIdRoute: typeof AuthenticatedAdminLlmUsageOrgIdRoute
  AuthenticatedAdminOrganizationsOrgIdRoute: typeof AuthenticatedAdminOrganizationsOrgIdRoute
  AuthenticatedAdminUsersUserIdRoute: typeof AuthenticatedAdminUsersUserIdRoute
  AuthenticatedAdminAiQualityIndexRoute: typeof AuthenticatedAdminAiQualityIndexRoute
  AuthenticatedAdminAuditReportsIndexRoute: typeof AuthenticatedAdminAuditReportsIndexRoute
  AuthenticatedAdminJobsIndexRoute: typeof AuthenticatedAdminJobsIndexRoute
  AuthenticatedAdminLlmUsageIndexRoute: typeof AuthenticatedAdminLlmUsageIndexRoute
  AuthenticatedAdminOrganizationsIndexRoute: typeof AuthenticatedAdminOrganizationsIndexRoute
  AuthenticatedAdminUsersIndexRoute: typeof AuthenticatedAdminUsersIndexRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAuditRoute: AuthenticatedAdminAuditRoute,
  AuthenticatedAdminIntegrationsRoute: AuthenticatedAdminIntegrationsRoute,
  AuthenticatedAdminInvitationsRoute: AuthenticatedAdminInvitationsRoute,
  AuthenticatedAdminManagedSpendRoute: AuthenticatedAdminManagedSpendRoute,
  AuthenticatedAdminSystemRoute: AuthenticatedAdminSystemRoute,
  AuthenticatedAdminUserAnalyticsRoute: AuthenticatedAdminUserAnalyticsRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  AuthenticatedAdminAuditReportsIntakeIdRoute:
    AuthenticatedAdminAuditReportsIntakeIdRoute,
  AuthenticatedAdminJobsJobIdRoute: AuthenticatedAdminJobsJobIdRoute,
  AuthenticatedAdminLlmUsageOrgIdRoute: AuthenticatedAdminLlmUsageOrgIdRoute,
  AuthenticatedAdminOrganizationsOrgIdRoute:
    AuthenticatedAdminOrganizationsOrgIdRoute,
  AuthenticatedAdminUsersUserIdRoute: AuthenticatedAdminUsersUserIdRoute,
  AuthenticatedAdminAiQualityIndexRoute: AuthenticatedAdminAiQualityIndexRoute,
  AuthenticatedAdminAuditReportsIndexRoute:
    AuthenticatedAdminAuditReportsIndexRoute,
  AuthenticatedAdminJobsIndexRoute: AuthenticatedAdminJobsIndexRoute,
  AuthenticatedAdminLlmUsageIndexRoute: AuthenticatedAdminLlmUsageIndexRoute,
  AuthenticatedAdminOrganizationsIndexRoute:
    AuthenticatedAdminOrganizationsIndexRoute,
  AuthenticatedAdminUsersIndexRoute: AuthenticatedAdminUsersIndexRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedAssetsRouteChildren {
  AuthenticatedAssetsAssetIdRoute: typeof AuthenticatedAssetsAssetIdRoute
  AuthenticatedAssetsIndexRoute: typeof AuthenticatedAssetsIndexRoute
}

const AuthenticatedAssetsRouteChildren: AuthenticatedAssetsRouteChildren = {
  AuthenticatedAssetsAssetIdRoute: AuthenticatedAssetsAssetIdRoute,
  AuthenticatedAssetsIndexRoute: AuthenticatedAssetsIndexRoute,
}

const AuthenticatedAssetsRouteWithChildren =
  AuthenticatedAssetsRoute._addFileChildren(AuthenticatedAssetsRouteChildren)

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsBillingRoute: typeof AuthenticatedSettingsBillingRoute
  AuthenticatedSettingsConnectionsRoute: typeof AuthenticatedSettingsConnectionsRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsSecurityRoute: typeof AuthenticatedSettingsSecurityRoute
  AuthenticatedSettingsTeamRoute: typeof AuthenticatedSettingsTeamRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsBillingRoute: AuthenticatedSettingsBillingRoute,
  AuthenticatedSettingsConnectionsRoute: AuthenticatedSettingsConnectionsRoute,
  AuthenticatedSettingsNotificationsRoute:
    AuthenticatedSettingsNotificationsRoute,
  AuthenticatedSettingsSecurityRoute: AuthenticatedSettingsSecurityRoute,
  AuthenticatedSettingsTeamRoute: AuthenticatedSettingsTeamRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedWizardCampaignsStrategyIdRouteChildren {
  AuthenticatedWizardCampaignsStrategyIdCampaignIndexRoute: typeof AuthenticatedWizardCampaignsStrategyIdCampaignIndexRoute
  AuthenticatedWizardCampaignsStrategyIdIndexRoute: typeof AuthenticatedWizardCampaignsStrategyIdIndexRoute
}

const AuthenticatedWizardCampaignsStrategyIdRouteChildren: AuthenticatedWizardCampaignsStrategyIdRouteChildren =
  {
    AuthenticatedWizardCampaignsStrategyIdCampaignIndexRoute:
      AuthenticatedWizardCampaignsStrategyIdCampaignIndexRoute,
    AuthenticatedWizardCampaignsStrategyIdIndexRoute:
      AuthenticatedWizardCampaignsStrategyIdIndexRoute,
  }

const AuthenticatedWizardCampaignsStrategyIdRouteWithChildren =
  AuthenticatedWizardCampaignsStrategyIdRoute._addFileChildren(
    AuthenticatedWizardCampaignsStrategyIdRouteChildren,
  )

interface AuthenticatedWizardRouteChildren {
  AuthenticatedWizardBriefRoute: typeof AuthenticatedWizardBriefRoute
  AuthenticatedWizardLaunchedRoute: typeof AuthenticatedWizardLaunchedRoute
  AuthenticatedWizardIndexRoute: typeof AuthenticatedWizardIndexRoute
  AuthenticatedWizardCampaignsStrategyIdRoute: typeof AuthenticatedWizardCampaignsStrategyIdRouteWithChildren
  AuthenticatedWizardPlanStrategyIdRoute: typeof AuthenticatedWizardPlanStrategyIdRoute
}

const AuthenticatedWizardRouteChildren: AuthenticatedWizardRouteChildren = {
  AuthenticatedWizardBriefRoute: AuthenticatedWizardBriefRoute,
  AuthenticatedWizardLaunchedRoute: AuthenticatedWizardLaunchedRoute,
  AuthenticatedWizardIndexRoute: AuthenticatedWizardIndexRoute,
  AuthenticatedWizardCampaignsStrategyIdRoute:
    AuthenticatedWizardCampaignsStrategyIdRouteWithChildren,
  AuthenticatedWizardPlanStrategyIdRoute:
    AuthenticatedWizardPlanStrategyIdRoute,
}

const AuthenticatedWizardRouteWithChildren =
  AuthenticatedWizardRoute._addFileChildren(AuthenticatedWizardRouteChildren)

interface AuthenticatedAgencySettingsRouteChildren {
  AuthenticatedAgencySettingsNotificationsRoute: typeof AuthenticatedAgencySettingsNotificationsRoute
  AuthenticatedAgencySettingsSecurityRoute: typeof AuthenticatedAgencySettingsSecurityRoute
  AuthenticatedAgencySettingsIndexRoute: typeof AuthenticatedAgencySettingsIndexRoute
}

const AuthenticatedAgencySettingsRouteChildren: AuthenticatedAgencySettingsRouteChildren =
  {
    AuthenticatedAgencySettingsNotificationsRoute:
      AuthenticatedAgencySettingsNotificationsRoute,
    AuthenticatedAgencySettingsSecurityRoute:
      AuthenticatedAgencySettingsSecurityRoute,
    AuthenticatedAgencySettingsIndexRoute:
      AuthenticatedAgencySettingsIndexRoute,
  }

const AuthenticatedAgencySettingsRouteWithChildren =
  AuthenticatedAgencySettingsRoute._addFileChildren(
    AuthenticatedAgencySettingsRouteChildren,
  )

interface AuthenticatedStrategiesStrategyIdRouteChildren {
  AuthenticatedStrategiesStrategyIdIndexRoute: typeof AuthenticatedStrategiesStrategyIdIndexRoute
  AuthenticatedStrategiesStrategyIdCampaignsCampaignIdRoute: typeof AuthenticatedStrategiesStrategyIdCampaignsCampaignIdRoute
}

const AuthenticatedStrategiesStrategyIdRouteChildren: AuthenticatedStrategiesStrategyIdRouteChildren =
  {
    AuthenticatedStrategiesStrategyIdIndexRoute:
      AuthenticatedStrategiesStrategyIdIndexRoute,
    AuthenticatedStrategiesStrategyIdCampaignsCampaignIdRoute:
      AuthenticatedStrategiesStrategyIdCampaignsCampaignIdRoute,
  }

const AuthenticatedStrategiesStrategyIdRouteWithChildren =
  AuthenticatedStrategiesStrategyIdRoute._addFileChildren(
    AuthenticatedStrategiesStrategyIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedAssetsRoute: typeof AuthenticatedAssetsRouteWithChildren
  AuthenticatedConnectGa4PropertyRoute: typeof AuthenticatedConnectGa4PropertyRoute
  AuthenticatedConnectGoogleAccountRoute: typeof AuthenticatedConnectGoogleAccountRoute
  AuthenticatedConnectGtmContainerRoute: typeof AuthenticatedConnectGtmContainerRoute
  AuthenticatedConnectMetaAssetsRoute: typeof AuthenticatedConnectMetaAssetsRoute
  AuthenticatedConnectPlatformsRoute: typeof AuthenticatedConnectPlatformsRoute
  AuthenticatedConnectorsRoute: typeof AuthenticatedConnectorsRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedExtendTrialRoute: typeof AuthenticatedExtendTrialRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedOrganizationSetupRoute: typeof AuthenticatedOrganizationSetupRoute
  AuthenticatedPaywallRoute: typeof AuthenticatedPaywallRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedSupportRoute: typeof AuthenticatedSupportRoute
  AuthenticatedWizardRoute: typeof AuthenticatedWizardRouteWithChildren
  AuthenticatedAgencyBillingRoute: typeof AuthenticatedAgencyBillingRoute
  AuthenticatedAgencyClientsRoute: typeof AuthenticatedAgencyClientsRoute
  AuthenticatedAgencyConnectionsRoute: typeof AuthenticatedAgencyConnectionsRoute
  AuthenticatedAgencyOnboardingRoute: typeof AuthenticatedAgencyOnboardingRoute
  AuthenticatedAgencySettingsRoute: typeof AuthenticatedAgencySettingsRouteWithChildren
  AuthenticatedAgencySetupRoute: typeof AuthenticatedAgencySetupRoute
  AuthenticatedAgencyTeamRoute: typeof AuthenticatedAgencyTeamRoute
  AuthenticatedAudiencesAudienceIdRoute: typeof AuthenticatedAudiencesAudienceIdRoute
  AuthenticatedBillingReturnRoute: typeof AuthenticatedBillingReturnRoute
  AuthenticatedGoalsGoalIdRoute: typeof AuthenticatedGoalsGoalIdRoute
  AuthenticatedStrategiesStrategyIdRoute: typeof AuthenticatedStrategiesStrategyIdRouteWithChildren
  AuthenticatedAgencyIndexRoute: typeof AuthenticatedAgencyIndexRoute
  AuthenticatedAiPerformanceIndexRoute: typeof AuthenticatedAiPerformanceIndexRoute
  AuthenticatedAudiencesIndexRoute: typeof AuthenticatedAudiencesIndexRoute
  AuthenticatedGoalsIndexRoute: typeof AuthenticatedGoalsIndexRoute
  AuthenticatedInsightsIndexRoute: typeof AuthenticatedInsightsIndexRoute
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
  AuthenticatedStrategiesIndexRoute: typeof AuthenticatedStrategiesIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedAssetsRoute: AuthenticatedAssetsRouteWithChildren,
  AuthenticatedConnectGa4PropertyRoute: AuthenticatedConnectGa4PropertyRoute,
  AuthenticatedConnectGoogleAccountRoute:
    AuthenticatedConnectGoogleAccountRoute,
  AuthenticatedConnectGtmContainerRoute: AuthenticatedConnectGtmContainerRoute,
  AuthenticatedConnectMetaAssetsRoute: AuthenticatedConnectMetaAssetsRoute,
  AuthenticatedConnectPlatformsRoute: AuthenticatedConnectPlatformsRoute,
  AuthenticatedConnectorsRoute: AuthenticatedConnectorsRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedExtendTrialRoute: AuthenticatedExtendTrialRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedOrganizationSetupRoute: AuthenticatedOrganizationSetupRoute,
  AuthenticatedPaywallRoute: AuthenticatedPaywallRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedSupportRoute: AuthenticatedSupportRoute,
  AuthenticatedWizardRoute: AuthenticatedWizardRouteWithChildren,
  AuthenticatedAgencyBillingRoute: AuthenticatedAgencyBillingRoute,
  AuthenticatedAgencyClientsRoute: AuthenticatedAgencyClientsRoute,
  AuthenticatedAgencyConnectionsRoute: AuthenticatedAgencyConnectionsRoute,
  AuthenticatedAgencyOnboardingRoute: AuthenticatedAgencyOnboardingRoute,
  AuthenticatedAgencySettingsRoute:
    AuthenticatedAgencySettingsRouteWithChildren,
  AuthenticatedAgencySetupRoute: AuthenticatedAgencySetupRoute,
  AuthenticatedAgencyTeamRoute: AuthenticatedAgencyTeamRoute,
  AuthenticatedAudiencesAudienceIdRoute: AuthenticatedAudiencesAudienceIdRoute,
  AuthenticatedBillingReturnRoute: AuthenticatedBillingReturnRoute,
  AuthenticatedGoalsGoalIdRoute: AuthenticatedGoalsGoalIdRoute,
  AuthenticatedStrategiesStrategyIdRoute:
    AuthenticatedStrategiesStrategyIdRouteWithChildren,
  AuthenticatedAgencyIndexRoute: AuthenticatedAgencyIndexRoute,
  AuthenticatedAiPerformanceIndexRoute: AuthenticatedAiPerformanceIndexRoute,
  AuthenticatedAudiencesIndexRoute: AuthenticatedAudiencesIndexRoute,
  AuthenticatedGoalsIndexRoute: AuthenticatedGoalsIndexRoute,
  AuthenticatedInsightsIndexRoute: AuthenticatedInsightsIndexRoute,
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
  AuthenticatedStrategiesIndexRoute: AuthenticatedStrategiesIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicSignupRoute: typeof PublicSignupRoute
  PublicVerifyEmailRoute: typeof PublicVerifyEmailRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicSignupRoute: PublicSignupRoute,
  PublicVerifyEmailRoute: PublicVerifyEmailRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  DataDeletionRoute: DataDeletionRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
